import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a3dd42e8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a3dd42e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dd42e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3dd42e8')) {
      api.createRecord('a3dd42e8', component.options)
    } else {
      api.reload('a3dd42e8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a3dd42e8&scoped=true&", function () {
      api.rerender('a3dd42e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserInfo/index.vue"
export default component.exports